import { useEffect, useState } from 'react';
import { PDFDownloadLink, pdf, Document, Page, View, Text, Image, StyleSheet } from "@react-pdf/renderer";
import { saveAs } from 'file-saver';
import logo from '../../assets/promatec-cafe.jpg'

const numToPrice = num => (num?.toFixed(2)?.replaceAll('.', ',') || '0,00')

const styles = StyleSheet.create({
  page: {
    padding: 24,
    position: 'relative',
    paddingBottom: 40
  },
  logo: {
    position: 'absolute',
    left: 24,
    top: 36,
    fontSize: 12,
    width: 100,
    height: 'auto'
  },
  title: {
    backgroundColor: '#DDD',
    fontSize: 12,
    fontWeight: 'bold',
    textAlign: 'center',
    // color: '#FFF'
    padding: '4px',
    border: '1px solid #BBB'
  },
  tableTitle: {
    backgroundColor: '#DDD',
    fontSize: 12,
    fontWeight: 'bold',
    textAlign: 'center',
    // color: '#FFF'
    padding: '4px',
    borderRight: '1px solid #BBB',
    borderLeft: '1px solid #BBB',
    borderTop: '1px solid #BBB',
    borderBottom: '2px solid #000',
    marginBottom: '2px'
  },
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0,
    borderColor: '#BBB',
  },
  tableRow: {
    flexDirection: "row",
  },
  tableCol: {
    width: "50%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    borderColor: '#BBB',
    padding: 2,
    // textAlign: 'center'
    verticalAlign: 'middle'
  },
  tableCell: {
    fontSize: 8,
    textAlign: 'center',
    margin: 'auto 0'
  },
  tableCellHeader: {
    fontSize: 8,
    fontWeight: 'bold',
    textAlign: 'center',
    margin: 'auto 0'
  },
  textDescription: {
    fontSize: 8,
    padding: '4px',
    border: '1px solid #CCC',
    margin: '8px 0'
  },
  titleInfos: {
    padding: '8px'
  },
  titleInfosText: {
    fontSize: 8,
    padding: '1px 0',
    textAlign: 'center'
  },
  infosText: {
    fontSize: 8,
    padding: '2px 0'
  },
  infosTextHidden: {
    height: '15px',
    padding: '2px 0'
  },
  textBold: {
    fontWeight: 'bold'
  },
  infos: {
    position: 'relative',
    marginTop: '8px'
  },
  infoMiddle: {
    position: 'absolute',
    left: '40%',
    top: 0,
  },
  infoEnd: {
    position: 'absolute',
    left: '70%',
    top: 0,
  },
  totalText: {
    fontSize: 10,
    padding: '2px 0',
    textAlign: 'right',
    marginTop: '2px',
    marginBottom: '12px'
  },
  infoMiddleClient: {
    position: 'absolute',
    left: '33%',
    top: 0,
  },
  infoEndClient: {
    position: 'absolute',
    left: '69%',
    top: 0,
  },
  infosTextClient: {
    fontSize: 8,
    padding: '2px 0'
  },
  signature: {
    fontSize: 10,
    paddingTop: '8px',
    borderTop: '1px solid #000',
    width: 240,
    textAlign: 'center',
    margin: '32px auto 0'
  },
  footer: {
    position: 'absolute',
    bottom: 20,
    left: 0,
    right: 0,
    textAlign: 'left',
    fontSize: 10,
    color: '#555',
    padding: '0 24px'
  },
  pageNumber: {
    position: 'absolute',
    bottom: 20,
    left: 0,
    right: 0,
    textAlign: 'right',
    fontSize: 10,
    color: '#000',
    padding: '0 24px'
  },
});

const MyPDF = ({ data, image, title }) => (
  <Document title={title || `OS ${data.OS_id || ''}`}>
    <Page size="A4" style={styles.page}>
      <Text
        style={styles.pageNumber}
        fixed
        render={({ pageNumber, totalPages }) => `Página ${pageNumber} de ${totalPages}`}
      />
      <Text style={styles.footer} fixed render={() => `OS ${data.OS_id} emitida em ${data.DataEmissao} por ${data.Responsavel}`} />
      <Image style={styles.logo} src={image} />
      <View style={styles.titleInfos}>
        <Text style={styles.titleInfosText}>PROMATEC CAFE LTDA ME</Text>
        <Text style={styles.titleInfosText}>CNPJ: 09048207000100</Text>
        <Text style={styles.titleInfosText}>Endereço: Rua Américo Brasiliense, 1377,</Text>
        <Text style={styles.titleInfosText}>Bairro: Vila Seixas | CEP: 14020025 | Cidade: Ribeirão Preto</Text>
        <Text style={styles.titleInfosText}>Estado: SP | País: Brasil</Text>
        <Text style={styles.titleInfosText}>Email: ADM@PROMATECCAFE.COM.BR</Text>
        <Text style={styles.titleInfosText}>Telefone: (16) 3441-9199</Text>
      </View>
      <Text style={styles.title}>Informações</Text>
      <View style={styles.infos}>
        <View>
          <Text style={styles.infosText}><Text style={styles.textBold}>Data Emissão:</Text> {data.DataEmissao || ''}</Text>
          <Text style={styles.infosText}><Text style={styles.textBold}>Duração:</Text> {data.duracao || ''}</Text>
          <Text style={styles.infosText}><Text style={styles.textBold}>Responsável:</Text> {data.Responsavel || ''}</Text>
          <Text style={styles.infosText}><Text style={styles.textBold}>Cliente:</Text> {data.cliente_razaoSocial || ''}</Text>
          <Text style={styles.infosText}><Text style={styles.textBold}>Nome Fantasia:</Text> {data.Cliente || ''}</Text>
          <Text style={styles.infosText}><Text style={styles.textBold}>Telefone:</Text> {data.clienteTelefone || ''}</Text>
          <Text style={styles.infosText}><Text style={styles.textBold}>Endereço:</Text> {data.clienteEndereco || ''}</Text>
          <Text style={styles.infosText}><Text style={styles.textBold}>Bairro:</Text> {data.clienteBairro || ''}</Text>
          <Text style={styles.infosText}><Text style={styles.textBold}>Estado:</Text> {data.clienteEstado || ''}</Text>
          <Text style={styles.infosText}><Text style={styles.textBold}>Complemento: {data.clienteComplemento || ''}</Text></Text>
        </View>
        <View style={styles.infoMiddle}>
          <Text style={styles.infosText}><Text style={styles.textBold}>Data Entrega:</Text> {data.DataEntrega || ''}</Text>
          <Text style={styles.infosTextHidden}></Text>
          <Text style={styles.infosTextHidden}></Text>
          <Text style={styles.infosTextHidden}></Text>
          <Text style={styles.infosText}><Text style={styles.textBold}>Celular:</Text> {data.clienteCelular || ''}</Text>
          <Text style={styles.infosTextHidden}></Text>
          <Text style={styles.infosText}><Text style={styles.textBold}>Cidade:</Text> {data.clienteCidade || ''}</Text>
          <Text style={styles.infosText}><Text style={styles.textBold}>País:</Text> {data.clientePais || 'Brasil'}</Text>
          <Text style={styles.infosTextHidden}></Text>
        </View>
        <View style={styles.infoEnd}>
          <Text style={styles.infosText}><Text style={styles.textBold}>Status:</Text> {data.os_status || ''}</Text>
          <Text style={styles.infosText}><Text style={styles.textBold}>Ordem de Serviço:</Text> {data.OS_id || ''}</Text>
          <Text style={styles.infosTextHidden}></Text>
          <Text style={styles.infosText}><Text style={styles.textBold}>CNPJ:</Text> {data.clienteCpf_cnpj || ''}</Text>
          <Text style={styles.infosTextHidden}></Text>
          <Text style={styles.infosTextHidden}></Text>
          <Text style={styles.infosText}><Text style={styles.textBold}>Número:</Text> {data.clienteNumero || ''}</Text>
          <Text style={styles.infosText}><Text style={styles.textBold}>CEP:</Text> {data.clienteCEP || ''}</Text>
          <Text style={styles.infosTextHidden}></Text>
          <Text style={styles.infosTextHidden}></Text>
        </View>
      </View>
      <Text style={styles.textDescription}><Text style={styles.textBold}>Descrição:</Text> {data.Descricao || ''}</Text>
      <Text style={styles.tableTitle}>Itens</Text>
      <View style={styles.table}>
        <View style={styles.tableRow} fixed>
          <View style={styles.tableCol}><Text style={styles.tableCellHeader}>Tipo</Text></View>
          <View style={{ ...styles.tableCol, minWidth: '25%' }}><Text style={styles.tableCellHeader}>Produtos / Serviços</Text></View>
          <View style={styles.tableCol}><Text style={styles.tableCellHeader}>Quantidade</Text></View>
          <View style={styles.tableCol}><Text style={styles.tableCellHeader}>Unitário R$</Text></View>
          <View style={styles.tableCol}><Text style={styles.tableCellHeader}>Desconto R$</Text></View>
          <View style={styles.tableCol}><Text style={styles.tableCellHeader}>Total</Text></View>
        </View>
        {(data.items || []).map((row, index) => (
          <View style={styles.tableRow} key={`items-${index}`} wrap={false}>
            <View style={styles.tableCol}><Text style={styles.tableCellHeader}>{row.tipo || ''}</Text></View>
            <View style={{ ...styles.tableCol, minWidth: '25%' }}><Text style={styles.tableCell}>{row.produto || ''}</Text></View>
            <View style={styles.tableCol}><Text style={styles.tableCell}>{row.quantidade}</Text></View>
            <View style={styles.tableCol}><Text style={styles.tableCell}>{numToPrice(row.valorUnitario || 0)}</Text></View>
            <View style={styles.tableCol}><Text style={styles.tableCell}>{numToPrice(row.desconto)}</Text></View>
            <View style={styles.tableCol}><Text style={styles.tableCell}>{numToPrice(row.valorTotal)}</Text></View>
          </View>
        ))}
      </View>
      <Text style={styles.totalText}><Text style={styles.textBold}>Total Geral R$:</Text> {numToPrice(data.total)}</Text>
      <View wrap={false}>
        <Text style={styles.title}>Itens do Cliente</Text>
        <View style={styles.infos}>
          <View>
            <Text style={styles.infosTextClient}>Data: ____/_____/_________</Text>
          </View>
          <View style={styles.infoMiddleClient}>
            <Text style={styles.infosTextClient}>Hora de entrada: ______:______</Text>
          </View>
          <View style={styles.infoEndClient}>
            <Text style={styles.infosTextClient}>Hora de saída: ______:______</Text>
          </View>
        </View>
        <View style={{ ...styles.table, marginTop: '16px' }}>
          <View style={styles.tableRow}>
            <View style={styles.tableCol}><Text style={styles.tableCellHeader}>Objeto de Manutenção</Text></View>
            <View style={styles.tableCol}><Text style={styles.tableCellHeader}>Quantidade</Text></View>
          </View>
          {(data.itemsClient || []).map((row, index) => (
            <View style={styles.tableRow} key={`items-client-${index}`} wrap={false}>
              <View style={styles.tableCol}><Text style={styles.tableCell}>{row.produto || ''}</Text></View>
              <View style={styles.tableCol}><Text style={styles.tableCell}>{row.quantidade || ''}</Text></View>
            </View>
          ))}
        </View>
        <View>
          <Text style={styles.signature}>Assinatura Cliente</Text>
        </View>
      </View>
    </Page>
  </Document>
);

const fetchImage = async () => {
  const res = await fetch(logo);
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  // URL + Revoke URL function
  return [url, () => URL.revokeObjectURL(url)];
}

// Nome do arquivo no padrao "OS 184 - MAIS UM COPO DE CAFE FIUSA 25-08-26"
// (a data e a de entrega da OS, nao a data de geracao do relatorio)
export const buildOSFileName = (data) => {
  const cliente = data?.Cliente || data?.cliente_razaoSocial || '';
  // DataEntrega chega como dd/MM/yyyy
  const [dia, mes, ano] = (data?.DataEntrega || '').split('/');
  const dataEntrega = (dia && mes && ano) ? `${dia}-${mes}-${ano.slice(-2)}` : '';

  return [`OS ${data?.OS_id || ''}`, '-', cliente, dataEntrega]
    .join(' ')
    .replace(/[\\/:*?"<>|]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

const buildPDFBlob = async (data, fileName) => {
  const [objectUrl, revokeLogo] = await fetchImage();
  try {
    return await pdf(<MyPDF data={data} image={objectUrl} title={fileName} />).toBlob();
  } finally {
    revokeLogo();
  }
}

// Abre o PDF em uma nova guia.
// targetWindow: guia ja aberta no clique do usuario (evita o bloqueio de pop-up),
// pois o PDF so fica pronto depois do await.
export const openPDF = async (data, fileName, targetWindow) => {
  const name = fileName || buildOSFileName(data);
  const newWindow = targetWindow || window.open('', '_blank');

  try {
    const blob = await buildPDFBlob(data, name);
    // File (e nao Blob) para o navegador sugerir o nome certo ao salvar pelo visualizador
    const file = new File([blob], `${name}.pdf`, { type: 'application/pdf' });
    const url = URL.createObjectURL(file);

    if (newWindow) {
      newWindow.location.href = url;
      return;
    }
    // Pop-up bloqueado: cai para o download
    saveAs(file, `${name}.pdf`);
  } catch (err) {
    newWindow?.close();
    throw err;
  }
}

// Just download PDF
export const savePDF = async (data, fileName) => {
  const name = fileName || buildOSFileName(data);
  const blob = await buildPDFBlob(data, name);
  saveAs(blob, `${name}.pdf`);
}

// Create a PDF Link as a Component
export default function PDFLink({ data, fileName, btnImprimir }) {
  const [objectUrl, setObjectUrl] = useState(null);

  useEffect(() => {
    let revokeFunc;
    fetchImage().then(([url, revoke]) => {
      setObjectUrl(url)
      revokeFunc = revoke
    })
    return () => revokeFunc?.();
  }, []);

  return (
    <PDFDownloadLink
      document={<MyPDF data={data} image={objectUrl} />}
      fileName={`${fileName}.pdf`}
    >
      {({ loading }) => btnImprimir ? btnImprimir(loading) : ((l) => (<span>{l ? 'Carregando...' : 'Imprimir'}</span>))}
    </PDFDownloadLink>
  );
}
